import { action } from "typesafe-actions";
import { Institution } from "../../types";

export const SET_INSTITUTION = "SET_INSTITUTION";

export const setInstitution = (payload: Institution) =>
  action(SET_INSTITUTION, payload);
